declare global {
  interface Window {
    $image_url?: (image: string) => string;
  }
}

/**
 * Generates a CDN URL for any asset in public/.
 * @param pathname - A path in /public (e.g., '/videos/ai_scientist/video.mp4')
 * @returns The CDN URL in production, or the original path in development fallback
 */
export function asset_url(pathname: string): string {
  if (process.env.NODE_ENV === 'development') {
    // DISABLE_ASSET_HOST is set per-worktree by ./dev_worktree; without an
    // asset host route, cfassets0.devdemia.com is unreachable from a worktree.
    // Strict-equality check — `"0"` is truthy in JS, so a loose check would
    // disable the asset host for anyone wiring `DISABLE_ASSET_HOST=0`.
    if (process.env.DISABLE_ASSET_HOST === '1') {
      return pathname;
    }
    // Returns correct url for dev environment, even in server-side rendering
    return `//cfassets0.devdemia.com${pathname}`;
  } else if (typeof window !== 'undefined' && window.$asset_host) {
    if (window.$rails_env === 'development') {
      // maintains consistency with rails img tag helpers
      return `//cfassets0.${window.$asset_host}${pathname}`;
    }
    return `//c.${window.$asset_host}${pathname}`;
  }

  // fallback to non-cdn path
  return pathname;
}

/**
 * replacement for @$image_url helper
 */
export default function $image_url(image: string): string {
  // regex for backwards compatibility
  if (image.match(/^((https?:)?\/\/|\/)/)) {
    return image;
  }

  return asset_url('/images/' + image);
}

export const imageUrl = $image_url;

// TODO:  Was originally in a_c/utils/index. global $image_url is stil used in pug templates and `app/assets/javascripts/core_post_webpack/widgets/deprecated_confirm.js`
if (typeof window !== 'undefined') {
  window.$image_url = $image_url;
}
